"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_customer__care__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.5 191.5",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:none;}.cls-3{fill:#fff;}.cls-4{fill:#e90000;}.cls-5{fill:#4a4d4e;}.cls-6,.cls-7{opacity:0.06;}.cls-10,.cls-13,.cls-14,.cls-6{mix-blend-mode:multiply;}.cls-12,.cls-8,.cls-9{opacity:0.2;}.cls-8{fill:url(#Unbenannter_Verlauf_12);}.cls-9{fill:url(#Unbenannter_Verlauf_12-2);}.cls-10{opacity:0.06;}.cls-11,.cls-14{opacity:0.12;}.cls-12{fill:url(#Unbenannter_Verlauf_12-3);}.cls-13,.cls-15{opacity:0.12;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12",
    x1: 32.25,
    y1: 87.05,
    x2: 59.07,
    y2: 113.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12-2",
    x1: 150.93,
    y1: 89.34,
    x2: 179.78,
    y2: 118.19,
    xlinkHref: "#Unbenannter_Verlauf_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_12-3",
    x1: 153.92,
    y1: 131.49,
    x2: 163.68,
    y2: 141.24,
    xlinkHref: "#Unbenannter_Verlauf_12"
  })), /*#__PURE__*/React.createElement("title", null, "customer-care-hi-dark"), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer_care_ic_hi_2",
    "data-name": "Customer_care_ic_hi 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-2",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.13,79.75H47.75a0,0,0,0,1,0,0v64.07a0,0,0,0,1,0,0H37.13a16,16,0,0,1-16-16V95.75A16,16,0,0,1,37.13,79.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.55,128h0V96.1h0A5.56,5.56,0,0,0,16,101.65v20.8A5.56,5.56,0,0,0,21.55,128Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.75,79.75h4.07a4,4,0,0,1,4,4v56.07a4,4,0,0,1-4,4H47.75a0,0,0,0,1,0,0V79.75A0,0,0,0,1,47.75,79.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.38,128v.07a16,16,0,0,0,16,16H48v-2H37.38a16,16,0,0,1-16-16V128Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.7,80h10.57a0,0,0,0,1,0,0v64.07a0,0,0,0,1,0,0H159.7a16,16,0,0,1-16-16V96A16,16,0,0,1,159.7,80Z",
    transform: "translate(313.71 223.82) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.27,128h0V96.1h0a5.56,5.56,0,0,1,5.55,5.55v20.8A5.56,5.56,0,0,1,170.27,128Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.73,80h4.07a4,4,0,0,1,4,4v56.07a4,4,0,0,1-4,4h-4.07a0,0,0,0,1,0,0V80A0,0,0,0,1,135.73,80Z",
    transform: "translate(279.28 223.82) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.8,144.07h-4.07a4,4,0,0,1-4-4v-2a4,4,0,0,0,4,4h4.07Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "47.74 125.2 32.05 109.66 39.52 79.77 47.75 79.75 47.74 125.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M170.29,127.68l-16.94-16.54,6-30.25h0a16,16,0,0,1,11,15.76Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.89,112a4,4,0,0,1-4-4V80.15A56.13,56.13,0,0,0,95.83,24.09,55.29,55.29,0,0,0,55.61,41,56.9,56.9,0,0,0,39.78,80.15V108a4,4,0,0,1-8,0V80.15A65,65,0,0,1,49.85,35.48a63.23,63.23,0,0,1,46-19.39,64.13,64.13,0,0,1,64.06,64.06V108A4,4,0,0,1,155.89,112Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.83,16.09a63.23,63.23,0,0,0-46,19.39c-.17.17-.33.35-.5.53a4,4,0,0,0,.1,5.56l3,3c1-1.23,2-2.43,3.14-3.57A55.29,55.29,0,0,1,95.83,24.09a56,56,0,0,1,43.4,20.62l3-3a4,4,0,0,0,.11-5.53A63.86,63.86,0,0,0,95.83,16.09Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.78,78.15v2A56.88,56.88,0,0,1,52.47,44.6l-.88-.89A56.9,56.9,0,0,0,39.78,78.15Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M151.89,78.15a55.77,55.77,0,0,0-11.78-34.32l-.88.88a55.75,55.75,0,0,1,12.66,35.44Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M95.83,22.09A55.29,55.29,0,0,0,55.61,39a56,56,0,0,0-4,4.68l.88.89c.5-.61,1-1.21,1.52-1.8s1.07-1.2,1.62-1.77A55.16,55.16,0,0,1,95.83,24.09c1,0,2.06,0,3.08.09.34,0,.67.05,1,.07.68.05,1.37.11,2,.18l1.15.15c.62.08,1.24.16,1.86.26l1.17.22c.61.11,1.2.23,1.8.36l1.15.26c.6.15,1.2.31,1.79.48l1.07.3c.64.19,1.27.4,1.9.61l.9.31c.76.28,1.52.57,2.26.88l.47.18c.93.39,1.84.8,2.74,1.24l.07,0c.86.41,1.7.85,2.53,1.31l.6.35c.65.36,1.29.74,1.92,1.13l.72.46c.58.38,1.17.76,1.74,1.16l.71.51q.86.61,1.68,1.26l.66.52c.57.45,1.13.92,1.68,1.4l.54.47c.62.55,1.22,1.12,1.82,1.7l.3.28a58.58,58.58,0,0,1,4,4.44l.88-.88A56,56,0,0,0,95.83,22.09Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M158.65,127.68l-1.06,16,.24,0a16.21,16.21,0,0,0,9.88-6.92h0Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.27,128v.07a16,16,0,0,1-16,16H143.8v-2h10.47a16,16,0,0,0,16-16V128Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M170.27,126.07V126a5.56,5.56,0,0,0,5.55-5.55v2a5.56,5.56,0,0,1-5.55,5.55v-1.93Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48,144.07h4.07a4,4,0,0,0,4-4v-2a4,4,0,0,1-4,4H48Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M21.55,126.07V126A5.56,5.56,0,0,1,16,120.45v2A5.56,5.56,0,0,0,21.55,128v-1.93Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.85,168H96a4,4,0,0,1,0-8h27.85a28,28,0,0,0,28-28v-1.45a4,4,0,0,1,8,0V132A36,36,0,0,1,123.85,168Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 79.72,
    y: 155.78,
    width: 32,
    height: 16,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.71,166a8.14,8.14,0,0,0,.26-2,8.26,8.26,0,0,0-.07-1,8,8,0,0,1-7.93,7H88A8,8,0,0,1,80,163a8.26,8.26,0,0,0-.07,1,8,8,0,0,0,8,8h16a8,8,0,0,0,6.93-4",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.9,168h12.95a36,36,0,0,0,36-36v-1.45s0-.07,0-.11a36,36,0,0,1-36,35.56H111.71",
    transform: "translate(-0.25 -0.25)"
  }))))));
}

var _default = ic_customer__care__dark;
exports.default = _default;